// media-gallery-mobile-fix.js — force carousel on mobile for Ritual/Dawn
(function () {
  function applyMobileCarousel() {
    const galleries = document.querySelectorAll('media-gallery');

    galleries.forEach((mg) => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (isMobile) {
        // 1) สลับ data-presentation ให้เป็น carousel
        mg.dataset.presentation = 'carousel';
        mg.classList.add('media-gallery--carousel');
        mg.classList.remove('media-gallery--grid', 'media-gallery--one-column', 'media-gallery--two-column');

        // 2) ซ่อน grid list ถ้ามี (ธีมจะเรนเดอร์มาพร้อมกันเมื่อเลือก grid)
        const grid = mg.querySelector('.media-gallery__grid');
        if (grid) grid.style.display = 'none';

        // 3) เปิด scroll แนวนอนให้คอนเทนเนอร์สไลด์
        const slides = mg.querySelector('.slideshow__slides') || mg.querySelector('.slider--mobile') || mg.querySelector('.product__media-list');
        if (slides) {
          slides.style.overflowX = 'auto';
          slides.style.webkitOverflowScrolling = 'touch';
          slides.style.scrollSnapType = 'x mandatory';
          slides.style.touchAction = 'pan-x';
          // ให้แต่ละสไลด์เต็มหน้าจอและจับ snap
          slides.querySelectorAll(':scope > *').forEach((li) => {
            li.style.flex = '0 0 100%';
            li.style.scrollSnapAlign = 'start';
          });
        }
      } else {
        // กลับสู่ desktop: แสดง grid ตามปกติ
        mg.dataset.presentation = 'grid';
        mg.classList.add('media-gallery--grid');
        const grid = mg.querySelector('.media-gallery__grid');
        if (grid) grid.style.display = '';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', applyMobileCarousel);
  window.addEventListener('resize', applyMobileCarousel);
})();
